import SelectRank from './SelectRank';

export default SelectRank;
